import * as React from 'react';
import { Field } from 'react-final-form';

import { Switch as BaseSwitch } from '../../switch/Switch';
import { FormItem } from './FormItem';

import type { VFFieldProps } from '../types';
import { DATA_FORM_INPUT } from '../../common/data';

export type SwitchProps = VFFieldProps<React.ComponentProps<typeof BaseSwitch>>;
export const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
  (
    {
      name,
      validate,
      className,
      inputClassName,
      inlineValidation,
      contentClassName,
      label,
      onChange: customOnChange,
      required,
      disabled,
      labelRight = true,
      validateWarning,
      ...other
    },
    ref
  ) => (
    <FormItem
      name={name}
      inlineValidation={inlineValidation}
      className={className}
      label={false}
      required={required}
      disabled={disabled}
      validateWarning={validateWarning}
      contentClassName={contentClassName}
    >
      <Field name={name} validate={validate} type={'checkbox'}>
        {({ input: { value, onChange, name, ...nother } }) => (
          <BaseSwitch
            {...DATA_FORM_INPUT(name)}
            className={inputClassName}
            ref={ref}
            name={name}
            {...other}
            {...nother}
            disabled={disabled}
            onChange={onChange}
            // @ts-ignore
            value={value}
            labelRight={labelRight}
          >
            {label ? ` ${label}` : null}
          </BaseSwitch>
        )}
      </Field>
    </FormItem>
  )
);
